import PropTypes from 'prop-types';
import React from 'react';
import { Box, Copy } from '@honda-canada/design-system-react';
import { useTranslation } from 'react-i18next';
import formatDrivingDistance from '../../utils/formatDrivingDistance';

import ModalCloseButton from './ModalCloseButton';
import themeStyles from './DealerDetailsModal.style';

const DealerModalHeader = themeStyles.apply(Box, 'DealerModalHeader');
const DealerName = themeStyles.apply(Copy, 'DealerName');
const Distance = themeStyles.apply(Box, 'Distance');

const DealerDetailsHeader = ({ dealer, onCloseClick }) => {
  const { drivingDistance, name } = dealer || {};
  const { t } = useTranslation();

  return (
    <DealerModalHeader>
      <DealerName data-testid="cy-dealer-details-name">{name}</DealerName>
      {Boolean(drivingDistance) && (
        <Distance data-testid="cy-dealer-distance">
          <Copy data-testid="cy-dealer-details-distance-value">{formatDrivingDistance(drivingDistance)}</Copy>
          <Copy data-testid="cy-dealer-details-distance-unit"> {t('Sub-apps.Dealers.kmLabel')}</Copy>
        </Distance>
      )}
      <ModalCloseButton onClick={onCloseClick} ariaLabel={t('Shared.Common.closeModalAria')} />
    </DealerModalHeader>
  );
};

DealerDetailsHeader.defaultProps = {
  dealer: {},
};

DealerDetailsHeader.propTypes = {
  dealer: PropTypes.shape({
    name: PropTypes.string,
    drivingDistance: PropTypes.number,
  }),
  onCloseClick: PropTypes.func.isRequired,
};

DealerDetailsHeader.displayName = 'DealerDetailsHeader';
export default DealerDetailsHeader;
